import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "docs-listing__header-menu"
}
const _hoisted_2 = {
  key: 1,
  class: "docs-listing__sortfilter docs-listing__sortfilter--header"
}
const _hoisted_3 = {
  key: 0,
  class: "layout__wrapper-inner container"
}
const _hoisted_4 = {
  key: 1,
  class: "layout__wrapper-inner container"
}
const _hoisted_5 = {
  key: 2,
  class: "layout__wrapper-inner container docs-listing__content"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "docs-listing__sortfilter docs-listing__sortfilter--body" }

import { computed, onBeforeMount, ref, Raw } from 'vue'
import {
  onBeforeRouteUpdate,
  RouteLocationNormalized,
  useRouter,
} from 'vue-router'

import RootPageLayout from '@/app/components/RootPageLayout.vue'
import BackLink from '@/app/components/BackLink.vue'
import DocsFilterType from '@/app/components/listing/DocsFilterType.vue'
import DocsSort from '@/app/components/listing/DocsSort.vue'
import ListDocs from '@/app/components/listing/ListDocs.vue'
import CustomListMenu from '@/app/components/custom.lists/CustomListMenu.vue'
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'
import LoadingError from '@/components/ui/LoadingError.vue'

import { CustomListsView, isEditableCustomList } from '@/models/custom.lists'
import { DocsView } from '@/models/doc'
import { ListView, createListViewByRoute20321 } from '@/models/docs.list'
import { useWait } from '@/app/composables/useWait'
import { Sentry } from '@/services/sentry'
import type {
  CustomListWithDocs,
  Doc,
  DocsUserDataResponse,
} from '@/models/interfaces'


export default /*@__PURE__*/_defineComponent({
  __name: 'LibraryList20321',
  props: {
    docs: {},
    docsUserData: {},
    lists: {}
  },
  setup(__props: any) {

const wait = useWait()
const router = useRouter()

const props = __props

const docsListView = ref<Raw<ListView> | null>(null)

// This view is passed to the Rename/Delete widget so that they can
// modify the prop.lists.
const customListsView = ref<Raw<CustomListsView>>(
  new CustomListsView(props.lists),
)

onBeforeMount(async () => {
  await createView(router.currentRoute.value)
})

onBeforeRouteUpdate(async (to) => {
  // We don't have any links on the page which navigate to a different
  // library list. So this only triggers when the sort/filter changes,
  // which is not strictly necessary. But it's not a significant delay
  // either. createListViewByRoute20321() does not need to hit the back
  // end.
  await createView(to)
})

async function createView(route: RouteLocationNormalized): Promise<void> {
  const routeName = route.name as string
  const params = route.params

  try {
    wait.start('Loading List')
    wait.end('Error Loading List')

    docsListView.value = await createListViewByRoute20321(
      routeName,
      params,
      props.docs,
      props.docsUserData,
      props.lists,
    )
  } catch (error: any) {
    console.error(error)
    wait.start('Error Loading List')
    Sentry.captureException(error)
  } finally {
    wait.end('Loading List')
  }
}

/**
 * Return whether or not the current page is a non-standard Custom List listing page.
 */
const showCustomListMenu = computed(() =>
  isEditableCustomList(docsListView.value?.customList),
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RootPageLayout, {
    class: "library-page",
    title: "",
    subtitle: docsListView.value?.pageTitle()
  }, {
    actions: _withCtx(() => [
      _createVNode(BackLink, { class: "docs-listing__backlink container" }),
      (showCustomListMenu.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (docsListView.value?.customList)
              ? (_openBlock(), _createBlock(CustomListMenu, {
                  key: 0,
                  position: "right",
                  list: docsListView.value.customList,
                  listsView: customListsView.value
                }, null, 8, ["list", "listsView"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (
          docsListView.value &&
          !_unref(wait).is('Loading List') &&
          !_unref(wait).is('Error Loading List')
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(DocsSort, {
              view: docsListView.value.docs() as DocsView,
              newStyle20321B: "",
              useQueryString: false
            }, null, 8, ["view"]),
            _createVNode(DocsFilterType, {
              view: docsListView.value.docs() as DocsView,
              newStyle20321B: ""
            }, null, 8, ["view"])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_unref(wait).is('Loading List'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(LoadingSpinner)
          ]))
        : (_unref(wait).is('Error Loading List'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(LoadingError)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (docsListView.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(DocsSort, {
                        view: docsListView.value.docs() as DocsView,
                        newStyle20321B: "",
                        useQueryString: false
                      }, null, 8, ["view"]),
                      _createVNode(DocsFilterType, {
                        view: docsListView.value.docs() as DocsView,
                        newStyle20321B: ""
                      }, null, 8, ["view"])
                    ]),
                    _createVNode(ListDocs, {
                      view: docsListView.value,
                      showDocSort: false,
                      listsView: customListsView.value
                    }, null, 8, ["view", "listsView"])
                  ]))
                : _createCommentVNode("", true)
            ]))
    ]),
    _: 1
  }, 8, ["subtitle"]))
}
}

})